"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var install_1 = require("./install");
var actionStack = [];
var isInstalled = false;
var uninstall;
function getCurrentAction() {
    return actionStack.length ? actionStack[actionStack.length - 1] : null;
}
exports.getCurrentAction = getCurrentAction;
function promiseMiddleware(next, action, actionType, args, actionContext) {
    if (!isInstalled) {
        uninstall = install_1.default();
        isInstalled = true;
    }
    try {
        actionStack.push(actionType);
        return next(action, actionType, args, actionContext);
    }
    finally {
        actionStack.pop();
        if (!actionStack.length) {
            uninstall();
            isInstalled = false;
        }
    }
}
exports.promiseMiddleware = promiseMiddleware;
